import { TableColumn } from '@ui/aos-lib';
import { SEARCH_HINTS } from '../../../shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { EquipmentListingFieldName } from '../../equipment/devices/components/devices.models';
import { ActionsColumnComponent } from './components/actions-column/actions-column.component';
import { UserRoleNameColumnComponent } from './components/user-role-name-column/user-role-name-column.component';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';

export enum UserRolesFieldName {
  RoleName = 'Name',
  RoleId = 'ExternalRoleName'
}
export const SEARCH_TYPES = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ALL,
    value: 1,
    types: [UserRolesFieldName.RoleName, UserRolesFieldName.RoleId],
    hintText: SEARCH_HINTS.Search
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ROLE_NAME,
    value: 2,
    types: [UserRolesFieldName.RoleName],
    hintText: SEARCH_HINTS.RoleName
  },
  {
    text: 'Role ID',
    value: 3,
    types: [UserRolesFieldName.RoleId],
    hintText: SEARCH_HINTS.RoleId
  }
];

export const tableConfig: TableColumn[] = [
  {
    field: 'roleName',
    title: TranslateRegistry.get.USER_ROLES.TABLE.ROLE_NAME,
    width: 300,
    sortable: true,
    cmp: UserRoleNameColumnComponent
  },
  { field: 'externalRoleName', title: TranslateRegistry.get.USER_ROLES.TABLE.ROLE_ID, width: 144, sortable: false },
  {
    field: 'id',
    title: TranslateRegistry.get.USER_ROLES.TABLE.ACTIONS,
    width: 64,
    sticky: true,
    sortable: false,
    cmp: ActionsColumnComponent
  }
];

export const userRolesTableSortFiled: Record<string, EquipmentListingFieldName> = {
  roleName: UserRolesFieldName.RoleName
};
